
















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { StepMixin, ErrorResponseMixin } from '@mixin';
import StoreDispatcher from '@service/StoreDispatcher';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            next: false,
            submitting: false,
            errorList: null,
            autosave: false,
        };
    },

    mixins: [
        StepMixin,
        ErrorResponseMixin,
    ],

    created() {
        this.prev.to = `/apply/${ this.projectId }/project/bedrag`;
    },

    methods: {
        click() {
            if (this.submitting) return;

            this.submitting = true;

            const data = {
                id: this.current.id,
                organisation_id: this.current.organisation_id,
            }
            return this.$store.dispatch('project/submit', data).then(response => {
                if (response instanceof Error) {
                    this.errorList = response.response.data.failed;
                    return false;
                }
                
                this.$router.push(`/apply/${ this.projectId }/confirmation/klaar`)
            });
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Bevestig extends Vue {}

